<template>
    <!-- 中间banner -->
<div class="banner">
    <a-carousel  autoplay >
        <div class="carousel">
        <img src="../../assets/img/carousel1.png" alt="">
        </div>
        <div class="carousel">
        <img src="@/assets/img/carousel2.png" alt="">
        </div>
    </a-carousel>
</div>
</template>
<script>
export default {
  props:["imgList"],
  created(){
    console.log(this.imgList,'imgList');
  }
}
</script>
<style lang="scss" scoped>
 
  .banner{
    position: relative;
    width: 100%;
    height: 10.625rem;
    .carousel{
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>